import {useState} from "react";
import notifier from "simple-react-notifications2";
import {CountersignDto} from "../../model/order/countersign";
import {customAxios} from "../customAxios";

export function useGetCountersignList() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<CountersignDto[]>();
    const [error, setError] = useState<Error>();

    async function execute(tenantId: number) {
        try {
            setLoading(true);
            const fetched = await getCountersignList(tenantId);
            setData(fetched);
            return fetched;
        }
        catch (e) {
            setError(e as Error);
            notifier.error((e as Error).message)
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {loading, data, error, execute};
}



export async function getCountersignList(tenantId: number): Promise<CountersignDto[]> {
    const response = await customAxios.get<CountersignDto[]>(`/v1/order/tenant/${tenantId}/countersign`);
    return response.data;
}